module.exports = __webpack_public_path__ + "img/stock2.77987828.png";